module.exports = __webpack_public_path__ + "static/media/17.26d42f20.mp3";